/*
 * @Author: Code-HHX
 * @Date: 2022-03-24 10:35:21
 * @LastEditors: Code-HHX
 * @LastEditTime: 2022-03-24 14:32:21
 * @Description: api 统一出口
 */

import user from "@/api/user";
import writer from "@/api/writer";

const api = { user, writer };

export default api;
